module.exports = __webpack_public_path__ + "media/images/zj11-w3-1aba808eecdbba279a0dd61ee3f4392a.png";